import { Sx } from "utils/sx";

export const pendingLeaderboardRowStyles: Sx = (theme) => ({
    minHeight: theme.spacing(6),
    position: "relative",
    display: "grid",
    flexGrow: 1,
    gridTemplateColumns: `minmax(${theme.spacing(6)}, auto) auto 1fr minmax(${theme.spacing(8.5)}, auto)`,
    gridTemplateRows: "1fr min-content",
    placeItems: "center",
    columnGap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 0),
    border: "2px solid transparent",
    backgroundColor: theme.palette.background.paper,
});
